

const WordsFromCeo = () => {
    return (

        <>
            <div className="grid grid-cols-11 items-start px-8 lg:px-32">
                <div className="col-span-11 lg:col-span-5">
                    <figure className="">
                        <img className="rounded-lg" src="/images/dummy-img.jpg" alt="" />
                    </figure>
                </div>
                <div className="col-span-11 lg:col-start-7 lg:col-span-5 py-4">
                    <p className="title-text-size text-white-900 animated-content">Words From Our CEO</p>
                    <br/>
                    <p className="text-md text-justify content-text-size ">Dear Valued Customers, Welcome to Sheel Waterproofing, where excellence meets waterproofing expertise! As the CEO, I'm proud to lead a team dedicated to providing cutting-edge solutions for your waterproofing needs. 
                    <br/><br/>
                    Our commitment to quality, innovation, and customer satisfaction is unmatched. Explore our website to discover how Sheel Waterproofing can protect your investments and ensure a watertight future for your projects.
                    <br/><br/> Best regards,
                    <br/> Shankar Karki CEO,
                    <br/> Sheel Waterproofing Nepal Pvt. Ltd.</p>
                </div>
            </div>
        </>

    )
}

export default WordsFromCeo